import { api } from '../../lib/api';

export const RETURN_STATUSES = [
  { value: 'Draft', label: 'Draft', tone: 'neutral' },
  { value: 'Posted', label: 'Posted', tone: 'success' },
  { value: 'Cancelled', label: 'Cancelled', tone: 'danger' },
];

export const returnStatusMeta = (status) =>
  RETURN_STATUSES.find((s) => s.value === status) || { value: status, label: status, tone: 'neutral' };

export const RETURN_REASONS = [
  { value: 'Damaged', label: 'Damaged' },
  { value: 'WrongItem', label: 'Wrong item' },
  { value: 'Expired', label: 'Expired / short shelf life' },
  { value: 'QualityIssue', label: 'Quality issue' },
  { value: 'Overstock', label: 'Overstock' },
  { value: 'Other', label: 'Other' },
];

export const returnReasonLabel = (value) =>
  RETURN_REASONS.find((r) => r.value === value)?.label || value;

export const CREDIT_NOTE_STATUSES = [
  { value: 'None', label: 'No credit', tone: 'neutral' },
  { value: 'Expected', label: 'Credit expected', tone: 'warning' },
  { value: 'Received', label: 'Credit received', tone: 'success' },
];

export const creditNoteStatusMeta = (status) =>
  CREDIT_NOTE_STATUSES.find((s) => s.value === status) || { value: status, label: status, tone: 'neutral' };

function toQuery(params) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.append(k, v);
  });
  const s = q.toString();
  return s ? `?${s}` : '';
}

export const returnsApi = {
  list: (params = {}) => api.get(`/supplier-returns${toQuery(params)}`),
  get: (id) => api.get(`/supplier-returns/${id}`),
  // payload.post === false saves a draft (no side effects); true posts immediately.
  create: (payload) => api.post('/supplier-returns', payload),
  post: (id) => api.post(`/supplier-returns/${id}/post`),
  cancel: (id, reason) => api.post(`/supplier-returns/${id}/cancel`, { reason: reason || null }),
  recordCreditNote: (id, payload) => api.post(`/supplier-returns/${id}/credit-note`, payload),
  listActivity: (id, params = {}) => api.get(`/supplier-returns/${id}/activity${toQuery(params)}`),
};
